import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '../layout/index.vue'
import layout_c from '../layout_c/index.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/layout_c/home'
	},
	//   {
	//     path: "/home",
	//     name: "home",
	//     component: () => import("@/views/home/index.vue"),
	//     meta: { title: "首页" },
	//   },
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/home',
				name: 'index',
				component: () => import('@/views/home/index.vue'),
				meta: { title: '首页' }
			}
		]
	},
	{
		path: '/login_c',
		name: 'login_c',
		component: () => import('@/views/login_c/index.vue'),
		meta: { title: '登陆页' }
	},
	{
		path: '/login_b',
		name: 'login_b',
		component: () => import('@/views/login_b/index.vue'),
		meta: { title: '登陆页' }
	},
	{
		path: '/layout',
		name: 'layout',
		component: layout,
		redirect: '/layout/homepage',
		children: [
			// {
			// 	path: '/layout/information',
			// 	name: 'information',
			// 	component: () => import('@/views/information/index.vue'),
			// 	meta: { title: '审核管理,报名信息审核' }
			// },
			// {
			// 	path: '/layout/information/details',
			// 	name: 'details',
			// 	component: () => import('@/views/information/details.vue'),
			// 	meta: { title: '审核管理,报名信息审核,报名信息详情' }
			// },
			{
				path: '/layout/homepage',
				name: 'homepage',
				component: () => import('@/views/homepage/index.vue'),
				meta: { title: '首页,统计看板' }
			},
			{
				path: '/layout/empty',
				name: 'empty',
				component: () => import('@/views/homepage/empty.vue'),
				meta: { title: '' }
			},
			{
				path: '/layout/competition',
				name: 'competition',
				component: () => import('@/views/competition/index.vue'),
				meta: { title: '比赛管理,比赛管理' }
			},
			{
				path: '/layout/newCompetition',
				name: 'newCompetition',
				component: () => import('@/views/competition/components/newCompetition.vue'),
				meta: { title: '比赛管理,比赛管理,新建比赛' }
			},
			{
				path: '/layout/matchDetails',
				name: 'matchDetails',
				component: () => import('@/views/competition/matchDetails.vue'),
				meta: { title: '比赛管理,比赛详情' }
			},
			{
				path: '/layout/slideshow',
				name: 'slideshow',
				component: () => import('@/views/slideshow/index.vue'),
				meta: { title: '运营管理,轮播图' }
			},
			{
				path: '/layout/mediaReports',
				name: 'mediaReports',
				component: () => import('@/views/mediaReports/index.vue'),
				meta: { title: '运营管理,大赛资讯' }
			},
			{
				path: '/layout/addNews',
				name: 'addNews',
				component: () => import('@/views/mediaReports/addNews.vue'),
				meta: { title: '运营管理,大赛资讯,添加大赛资讯' }
			},
			{
				path: '/layout/resultsShow',
				name: 'resultsShow',
				component: () => import('@/views/resultsShow/index.vue'),
				meta: { title: '运营管理,成果展示' }
			},
			{
				path: '/layout/postManagement',
				name: 'postManagement',
				component: () => import('@/views/postManagement/index.vue'),
				meta: { title: '运营管理,帖子管理' }
			},
			{
				path: '/layout/messageNotice',
				name: 'messageNotice',
				component: () => import('@/views/messageNotice/index.vue'),
				meta: { title: '运营管理,消息管理' }
			},
			// {
			// 	path: '/layout/uploadData',
			// 	name: 'uploadData',
			// 	component: () => import('@/views/uploadData/index.vue'),
			// 	meta: { title: '比赛管理,上次资料时间' }
			// },
			{
				path: '/layout/serviceManagement',
				name: 'serviceManagement',
				component: () => import('@/views/serviceManagement'),
				meta: { title: '模型市场,服务管理' }
			},
			{
				path: '/layout/modelManagement',
				name: 'modelManagement',
				component: () => import('@/views/modelManagement'),
				meta: { title: '模型市场,模型管理' }
			},
			{
				path: '/layout/registered',
				name: 'registered',
				component: () => import('@/views/registered/index.vue'),
				meta: { title: '用户管理,注册用户' }
			},
			{
				path: '/layout/background',
				name: 'background',
				component: () => import('@/views/background/index.vue'),
				meta: { title: '用户管理,后台用户' }
			},
			{
				path: '/layout/realnameAuth',
				name: 'realnameAuth',
				component: () => import('@/views/realnameAuth/index.vue'),
				meta: { title: '用户管理,实名认证' }
			},
			{
				path: '/layout/depart',
				name: 'depart',
				component: () => import('@/views/system/depart.vue'),
				meta: { title: '系统管理,部门管理' }
			},
			{
				path: '/layout/role',
				name: 'role',
				component: () => import('@/views/system/role.vue'),
				meta: { title: '系统管理,角色管理' }
			}
		]
	},

	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/announcement',
				name: 'announcement',
				component: () => import('@/views/announcement/index.vue'),
				meta: { title: '大赛公告' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/CompetitionInformation',
				name: 'CompetitionInformation',
				component: () => import('@/views/CompetitionInformation/index.vue'),
				meta: { title: '大赛资讯' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/game/details',
				name: 'details',
				component: () => import('@/views/game/details.vue'),
				meta: { title: '我的比赛/详情' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/game/modify',
				name: 'modify',
				component: () => import('@/views/signUp/index.vue'),
				meta: { title: '我的比赛/修改' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/signUp',
				name: 'signUp',
				component: () => import('@/views/signUp/index.vue'),
				meta: { title: '大赛报名' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/game',
				name: 'game',
				component: () => import('@/views/game/index.vue'),
				meta: { title: '我的比赛' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/problem',
				name: 'problem',
				component: () => import('@/views/problem/index.vue'),
				meta: { title: '问题和解答' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/user',
				name: 'user',
				component: () => import('@/views/user/index.vue'),
				meta: { title: '用户' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/competition',
				name: 'competition',
				component: () => import('@/views/competition_c/index.vue'),
				meta: { title: '比赛' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				// /layout_c/competition/details
				path: '/layout_c/details',
				name: 'competitionDetails',
				component: () => import('@/views/competition_c/details.vue'),
				meta: { title: '复制链接邀请成员' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/myCompet',
				name: 'myCompet',
				component: () => import('@/views/myCompet/index.vue'),
				meta: { title: '我的比赛' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/post',
				name: 'post',
				component: () => import('@/views/post/index.vue'),
				meta: { title: '发布帖子' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/post/details',
				name: 'postDetails',
				component: () => import('@/views/post/details.vue'),
				meta: { title: '帖子详情' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/copyLinkInvites',
				name: 'copyLinkInvites',
				component: () => import('@/views/CopyLinkInvites/index.vue'),
				meta: { title: '复制链接邀请成员' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/mode',
				name: 'mode',
				component: () => import('@/views/modeC/index.vue'),
				meta: { title: '模型市场' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/modeShow',
				name: 'modeShow',
				component: () => import('@/views/modeC/rozhanshile.vue'),
				meta: { title: '模型市场/成果展示' }
			}
		]
	},
	{
		path: '/layout_c',
		name: 'layout_c',
		component: layout_c,
		children: [
			{
				path: '/layout_c/modeKeyword',
				name: 'mode',
				component: () => import('@/views/modeKeyword/index.vue'),
				meta: { title: '模型市场/关键词抽取' }
			}
		]
	}
]

const router = new VueRouter({
	routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch((err) => err)
}

export default router
